export const ITEMS_PER_PAGE = 20;

export const createPageFromOffset = (offset: number = 0): number => (offset === 0 ? 1 : offset / ITEMS_PER_PAGE + 1);

export const createOffsetFromPage = (page: number | string | string[] = 0, offset?: string): number => {
  if (offset !== undefined && offset.trim() !== '' && !Number.isNaN(offset)) return parseInt(offset, 10);
  return page ? (parseInt(page.toString(), 10) - 1) * ITEMS_PER_PAGE : 0;
};
